'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.venueShorthandOnEnterSaga = venueShorthandOnEnterSaga;

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _bound = require('redux/saga/entities/bound');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(venueShorthandOnEnterSaga);

function venueShorthandOnEnterSaga(client, nextState, replaceState) {
  var venue;
  return _regenerator2.default.wrap(function venueShorthandOnEnterSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.venueByIdV2, [client, nextState.params.venueId]);

        case 2:
          venue = _context.sent;

          if (!venue) {
            _context.next = 6;
            break;
          }

          _context.next = 6;
          return (0, _effects.call)(replaceState, {
            pathname: '/studios/' + venue.alias,
            state: { status: 301 }
          });

        case 6:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}